/**************
 Menu Scroll
 ***************/

const header = document.querySelector('#header').parentElement;
const announcement = document.querySelector('#announcement');

// on scroll, when moving down,hide menu. On scroll up, roll menu back
let scrollPosition = window.scrollY;

function hideOnScroll() {
    window.scrollY > scrollPosition
        ?
        // make sure the announement bar is scrolled off
        announcement.getBoundingClientRect().bottom <= 0
            ? header.style.transform = 'translateY(-110%)'
            : ""
        : header.style.transform = 'translateY(0)';
    // reset current comparison
    scrollPosition = window.scrollY;
}

//window.addEventListener('scroll', hideOnScroll);

/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    // show dialog
    document.querySelector("#slider").showModal();

    // add active class to content
    document.querySelector("#sliderContent").classList.add("active");

    // add no scroll
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
function closeNav() {

    // remove active class to content
    document.querySelector("#sliderContent").classList.remove("active");

    // wait for transition to end
    setTimeout(() => {
        // close dialog
        document.querySelector("#slider").close();
        // remove no scroll
        document.querySelector("body").classList.remove("noScroll");
    }, 400);
}


// close on outside click

document.querySelector('#slider').addEventListener('click', function (e) {
    // close on outside click
    if (e.target === this) {
        closeNav();
    }
})

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});